import { lazyPinLikeSurfaceAction } from 'owa-surface-actions-option';

export default async function pinLikeSurfaceAction() {
    const pinLikeSurfaceAction = await lazyPinLikeSurfaceAction.import();
    pinLikeSurfaceAction();
}
